export default __webpack_public_path__ + "static/media/cabourg20.03231fa0.jpg";